import { render, staticRenderFns } from "./CaseItemM.vue?vue&type=template&id=71ab4718&scoped=true"
import script from "./CaseItemM.vue?vue&type=script&lang=ts"
export * from "./CaseItemM.vue?vue&type=script&lang=ts"
import style0 from "./CaseItemM.vue?vue&type=style&index=0&id=71ab4718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab4718",
  null
  
)

export default component.exports